/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {HttpErrorResponse} from '@angular/common/http';
import {ErrorHandler, Inject, Injectable, Injector, NgZone} from '@angular/core';
import {Router} from '@angular/router';
import {Environment} from 'compob2b-libs';
import {HTTP_STATUS} from '../constants';

@Injectable({
  providedIn: 'root'
})

/**
 * Globally handles auth errors
 * and redirects to sign-in page
 * {@link https://angular.io/api/core/ErrorHandler#description}
 */
export class CompoErrorHandler implements ErrorHandler {

  constructor(private readonly ngZone: NgZone,
              private readonly injector: Injector,
              @Inject('environment') private readonly environment: Environment) {
  }

  handleError(error): void {
    console.error('Global Error: ', error);

    const router = this.injector.get(Router);

    if (error instanceof HttpErrorResponse) {
      if (!this.environment.isOpenCabinet && (error.status === HTTP_STATUS.FORBIDDEN || error.status === HTTP_STATUS.UNAUTHORIZED)) {
        this.ngZone.run(() => router.navigate(['/sign-in']));
      } else if (this.environment.isOpenCabinet && (error.status === HTTP_STATUS.NOT_FOUND)) {
        this.ngZone.run(() => router.navigate(['/404']));
      } else {
        throw error;
      }
    }
  }
}
